// TODO: Once the Pandora integration is complete, remove this file. Migrate its contents to the Pandora library and update the app to use the types from that library.

// Global constants for Builder.io page components
export const PAGE_LAYOUT_TYPES = {
  /**
   * @deprecated This value will be removed soon. It will be replaced by PAGE_CREATOR_DEFAULT once the integration with Builder is updated.
   *
   * TODO: Review the PageLayout enum, also contains the 'default' value, which is used in the app,
   * possibly referring to the same layout. The usage and relationship between these values is currently unclear.
   * Consider checking it and avoid inconsistencies.
   */
  DEFAULT: 'default',
} as const;

export const PAGE_COMPONENT_TYPES = {
  PAGE_CONTAINER: 'page-container',
  PAGE_TITLE: 'page-title',
  // The following components have not yet been implemented in Pandora, but are future candidates
  BUILDER_SECTION: 'builder-section',
  PRODUCT_GRID: 'product-grid',
  PRODUCT_CAROUSEL: 'product-carousel',
  CATEGORY_BANNER: 'category-banner',
  TIMER_BANNER: 'timer-banner',
  SLIDESHOW: 'slideshow',
  CAROUSEL: 'carousel',
  // Submenu page component is not part of the model of Builder. Was added with this plugin:
  // https://github.com/Scalefast/builder-io-custom-types-plugin/blob/master/src/models/custom-component.model.ts#L24
  SUBMENU: 'submenu',
} as const;

// Extracts the values of an object type T and creates a union type.
// It works by obtaining all keys of T (keyof T) and using them to access their corresponding values (T[keyof T]).
// Example:
// const COLORS = { RED: 'red', BLUE: 'blue' } as const;
// type Color = ValueOf<typeof COLORS>; // 'red' | 'blue'
export type ValueOf<T> = T[keyof T];

// Type definitions
export type DefaultPageComponentType = ValueOf<typeof PAGE_COMPONENT_TYPES>;
export type PageLayoutType = ValueOf<typeof PAGE_LAYOUT_TYPES>;

// Type guards
export function isPageLayoutType(id: string): id is PageLayoutType {
  return [...Object.values(PAGE_LAYOUT_TYPES)].includes(id as PageLayoutType);
}
